import { atom } from 'recoil';
import { v4 } from 'uuid';
const DEFAULT_SESSION_ID_PREFIX = 'rtviewer3';

const STATIC_SESSION_ID = import.meta.env.VITE_STATIC_SESSION_ID;

export const sessionIDState = atom<string>({
    key: 'sessionIDState',
    default: STATIC_SESSION_ID ?? generateSessionId(),
});

export function generateSessionId(): string {
    const uuid = v4().replaceAll('-', '');
    return `${DEFAULT_SESSION_ID_PREFIX}.${uuid}`;
}
